import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import _ from 'underscore';
import { makeStyles } from '@mui/styles';
import {
	Card,
	CardHeader,
	colors,
} from '@mui/material';
import { FetchDownloads } from 'actions';
import DownloadList from '../../../../Downloads/components/DownloadList';

const useStyles = makeStyles((theme) => ({
	root: {
		marginTop: theme.spacing(4),
		padding: theme.spacing(2),
	},
}));

const reportTypes = [
	{ value: 'hourly24', text: '24 Hours' },
	{ value: 'hourly48', text: '48 Hours' },
	{ value: 'daily7', text: '7 Days' },
];

const SiteList = (props) => {
	const { className, ...rest } = props;
	const dispatch = useDispatch();
	const classes = useStyles();
	const user = useSelector((state) => state.session.user);
	const files = useSelector(state => state.session.downloads);

	useEffect(() => {
		dispatch(FetchDownloads(user.id, 'reportKpis'));
	}, []);

	return (
		<Card {...rest} className={clsx(classes.root, className)}>
			<CardHeader title="Downloads" />
			<DownloadList files={files} />
		</Card>
	);
};

SiteList.propTypes = {
	className: PropTypes.string
};

export default SiteList;
